import { BaseContainerModel } from '../base-container.model';
import {bl_fi_generic_doc_ext_RowClass} from '../../dbschema';

export class GenericDocExtContainerModel extends BaseContainerModel {

  bl_fi_generic_doc_ext: bl_fi_generic_doc_ext_RowClass = new bl_fi_generic_doc_ext_RowClass();
}
